/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_0_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The open-source license allows use under MIT or Apache-2.0 terms. Downloading the app and using the browser build are different ways to run the software. Keep the version number with any notes about a feature: this guide describes the v0.7.0 build provided here, not every future release.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_0_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目提供 MIT 或 Apache-2.0 开源许可。下载桌面应用和使用浏览器构建，是运行软件的不同方式。记录功能时应同时记下版本号：本指南描述本站提供的 v0.7.0，而非所有未来版本。`)
};

/**
* | output |
* | --- |
* | "The open-source license allows use under MIT or Apache-2.0 terms. Downloading the app and using the browser build are different ways to run the software. Kee..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_0_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_0_paragraphs_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_0_paragraphs_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_0_paragraphs_1 as "gc.search_guides.what_is_gridcraft.sections.0.paragraphs.1" }